export default {
  primary: {
    50: '#84878e',
    100: '#6b6e77',
    200: '#525661',
    300: '#393e4a',
    400: '#212634',
    500: '#080e1d',
    600: '#070d1a',
    700: '#060b17',
    800: '#060a14',
    900: '#050811',
  },
  orange: {
    50: '#FFF6E6',
    100: '#FEE6B8',
    200: '#FED68B',
    300: '#FDC65E',
    400: '#FCB630',
    500: '#FCA603',
    600: '#C98503',
    700: '#976302',
    800: '#654201',
    900: '#322101',
  },
  cyan: {
    50: '#E5FCFF',
    100: '#B8F7FF',
    200: '#8AF2FF',
    300: '#5CEDFF',
    400: '#2EE8FF',
    500: '#00E3FF',
    600: '#00B6CC',
    700: '#008899',
    800: '#005B66',
    900: '#002D33',
  },
  red: {
    50: '#FDE8EF',
    100: '#F9BED1',
    200: '#F494B4',
    300: '#F06B97',
    400: '#EC4179',
    500: '#E8175C',
    600: '#BA124A',
    700: '#8B0E37',
    800: '#5D0925',
    900: '#2E0512',
  },
  yellow: {
    50: '#FEFFE5',
    100: '#FBFFB8',
    200: '#F9FF8A',
    300: '#F6FF5C',
    400: '#F4FF2E',
    500: '#F1FF00',
    600: '#C1CC00',
    700: '#919900',
    800: '#606600',
    900: '#303300',
  },
  green: {
    50: '#E6FEF1',
    100: '#BAFDD7',
    200: '#8DFCBD',
    300: '#61FAA3',
    400: '#34F989',
    500: '#08F76F',
    600: '#06C659',
    700: '#059442',
    800: '#03632C',
    900: '#023116',
  },
};
